/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type PiiFilterConfigColumn = (typeof PiiFilterConfigColumn)[keyof typeof PiiFilterConfigColumn];

export const PiiFilterConfigColumn = {
  pii: 'pii',
} as const;
